import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
	ErrorStatusTypes,
	ErrorsStack,
} from "../../../../common/errorsDeclarations";

import {
	Lotto,
	getLotto,
	PianificazioneStrutturaState,
} from "../../../pianificazione/pianificazioneSlice";

import * as kgCommittentiApi from "../../../../../api/reportistica/reportisticaApi";
import moment from "moment";
import { toast } from "react-toastify";

moment.locale("it");
// export interface StatoConsuntivoVivo {
// 	stato: number;
// 	descrizione: string;
// 	messaggio: string;
// }

type LottoRidotto = Omit<
	Lotto,
	| "stato_lotto"
	// | "committente"
	// | "committente_desc"
	| "produttore"
	| "produttore_pack"
	| "m4_inviato"
	| "m4_inviati"
	| "in_dubbio"
	| "note_dubbio"
	| "calcolo_codice_tracciabilita_automatico"
	| "tipo_capo"
	| "peso_medio"
	| "colore"
	| "capi_schedulati"
	| "capi_ritirati"
	| "numero_capi_foro"
	| "numero_fori"
	| "fori_schedulati"
	| "peso_medio_lotto_arrivo"
	| "allevamento"
	| "note"
	| "schede_carico"
	| "consuntivi_vivo"
	| "lavorazioni_lotto"
	| "num_tz_pianificati_lotto"
	| "num_tz_eviscerati_pianificati_lotto"
	| "scheda_macello"
	| "data_ora_inizio_macello"
	| "data_ora_fine_macello"
	| "capi_ritirati"
	| "numero_capi_morti"
	| "numero_scarti_1"
	| "numero_scarti_2"
	| "num_busti_lotto"
	| "peso_casse_busto_lotto"
	| "num_tz_lotto"
	| "peso_casse_tz_lotto"
	| "percentuale_resa"
>;

export interface KgCommittenti extends LottoRidotto {
	id: number | null;
	data_lavorazione: Date | string;
	committente: number | null;
	committente_desc: string;
	peso_lotto_partenza?: number | null;
	peso_lotto_arrivo?: number | null;
	errorsStack: ErrorsStack;
}
export interface KgCommittentiState {
	count: number;
	page: number;
	num_pages: number;
	next?: URL;
	previous?: URL;
	results: KgCommittenti[];
	errorsStack: ErrorsStack;
}

export interface KgCommittentiStrutturaState {
	kgCommittenti: KgCommittentiState;
}

const initialState: KgCommittentiStrutturaState = {
	kgCommittenti: {
		count: 0,
		page: 0,
		num_pages: 0,
		next: undefined,
		previous: undefined,
		results: [],
		errorsStack: { status: ErrorStatusTypes.OK },
	},
};

export const fetchKgCommittenti = createAsyncThunk(
	"kgCommittente/fetchKgCommittenti",
	async (dataRange?: { data_da?: Date; data_a?: Date }) => {
		return await kgCommittentiApi.fetchKgCommittenti(
			dataRange?.data_da,
			dataRange?.data_a
		);
	}
);

export const kgCommittentiSlice = createSlice({
	name: "kgCommittentiState",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		// fetch dati per il report kgCommittenti
		builder.addCase(fetchKgCommittenti.pending, (state, action) => {
			state.kgCommittenti.errorsStack = {
				status: ErrorStatusTypes.PENDING,
			};
		});
		builder.addCase(fetchKgCommittenti.fulfilled, (state, action) => {
			state.kgCommittenti = action.payload;

			state.kgCommittenti.errorsStack = { status: ErrorStatusTypes.OK };
		});
		builder.addCase(fetchKgCommittenti.rejected, (state, action) => {
			toast.error("Errore:" + action?.error?.message || "");
			state.kgCommittenti.errorsStack = {
				status: ErrorStatusTypes.ERROR,
				fieldsErrors: JSON.parse(action?.error?.message || ""),
			};
		});
	},
});

// Action creators are generated for each case reducer function
export const {} = kgCommittentiSlice.actions;

export const kgCommittentiSliceReducer = kgCommittentiSlice.reducer;
